import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Footer from '../Footer/Footer';
import "./Forgotpassword.css";


const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const resetLink = `https://yourdomain.com/reset-password?token=${Date.now()}`;

    const templateParams = {
      to_email: email,
      reset_link: resetLink
    };

    emailjs.send('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', templateParams, 'YOUR_USER_ID')
      .then(() => {
        setSent(true);
      }).catch(err => {
        console.error('Error:', err);
      });
  };

  return (
     <>

    <div className="forgot-password-container">
      <h2>Forgot Password</h2>
      {sent ? (
        <p>Reset link has been sent to your email!</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
      )}
     
    </div>
  
  </>
  );
};

export default ForgotPassword;
